export default function SectionHeading({ number, title, className = '' }) {
  return (
    <div className={`section-heading ${className}`}>
      <span className="section-number">{number}</span>
      <h2 className="section-title">{title}</h2>
      <span className="section-line" aria-hidden="true" />
    </div>
  );
}
